import React from "react";
import { AnimatedCheckbox } from "app/uicomponents/microcomponents/AnimatedChecbox";
import { useIPContext } from "app/pages/InteractiveProposal/InteractiveProposalProvider";
import { PROPOSAL_STATUSES, THEME } from "app/utils/types";
import { getSessionStore } from "app/utils/sessionStore";
import { getThemeColors } from "app/utils/utils";

interface FilterOption {
  name: string;
  id: string;
  indicator?: boolean;
  indicatorColor?: string;
}
interface FilterGroupProps {
  title: string; // Title for the filter group
  options: FilterOption[]; // Array of options for the checkboxes
  selectedOptions: Record<string, boolean>;
  setSelectedOptions: (newSelectedOptions: Record<string, boolean>, optionId?: string) => void;
  className?: string; // Optional className for dynamic styling
  brandingColor?: string;
  hideCheckbox?: boolean;
  isTooltip?: boolean;
}
const FilterGroupContainer: React.FC<FilterGroupProps> = ({
  title,
  options,
  selectedOptions,
  setSelectedOptions,
  className,
  brandingColor,
  hideCheckbox = false,
  isTooltip = false,
}) => {
  const { proposalStatus } = useIPContext();
  const isPlanOrInactive = [
    PROPOSAL_STATUSES.PLAN_CREATED,
    PROPOSAL_STATUSES.REVOKED,
    PROPOSAL_STATUSES.IN_ACTIVE,
  ].includes(proposalStatus as any);
  const globalTheme = getSessionStore("globalTheme");
  const isDarkMode = globalTheme === THEME.DARK;
  const { branding } = getSessionStore("lookUpResponse");
  const { secondaryColor } = getThemeColors(branding);
  return (
    <div className={`flex flex-col ${className}`}>
      <h3 className="font-bold text-lg mb-2 conthrax-font">{title}</h3>
      <div className="flex flex-wrap max-h-[95px] gap-2 !overflow-auto">
        {options?.map((option) => (
          <div key={option?.id} className="rounded-full">
            <AnimatedCheckbox
              checked={selectedOptions[option?.id]}
              isTooltip={isTooltip}
              onChange={() => {
                const newSelectedOptions = {
                  ...selectedOptions,
                  [option?.id]: !selectedOptions[option.id],
                };
                setSelectedOptions(newSelectedOptions, option?.id);
              }}
              inputId={option?.id}
              label={option?.name}
              indicator={option?.indicator}
              indicatorColor={option?.indicatorColor}
              brandingColor={
                option?.name === "Key Person(s) Value" ||
                option?.name === "Shareholder Value" ||
                option?.name === "Financing"
                  ? "#808080"
                  : isDarkMode
                  ? secondaryColor
                  : brandingColor
              }
              isDisabled={isPlanOrInactive}
              hideCheckbox={hideCheckbox}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
export default FilterGroupContainer;
